"use strict";
import { __require as T } from "./index.es47.js";
var b, F;
function w() {
  if (F) return b;
  F = 1;
  var O = /* @__PURE__ */ T(), s = Object.prototype.hasOwnProperty, x = Array.isArray, l = (function() {
    for (var i = [], e = 0; e < 256; ++e)
      i.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
    return i;
  })(), g = function(e) {
    for (; e.length > 1; ) {
      var r = e.pop(), n = r.obj[r.prop];
      if (x(n)) {
        for (var f = [], u = 0; u < n.length; ++u)
          typeof n[u] < "u" && f.push(n[u]);
        r.obj[r.prop] = f;
      }
    }
  }, d = function(e, r) {
    for (var n = r && r.plainObjects ? { __proto__: null } : {}, f = 0; f < e.length; ++f)
      typeof e[f] < "u" && (n[f] = e[f]);
    return n;
  }, E = function i(e, r, n) {
    if (!r)
      return e;
    if (typeof r != "object" && typeof r != "function") {
      if (x(e))
        e.push(r);
      else if (e && typeof e == "object")
        (n && (n.plainObjects || n.allowPrototypes) || !s.call(Object.prototype, r)) && (e[r] = !0);
      else
        return [e, r];
      return e;
    }
    if (!e || typeof e != "object")
      return [e].concat(r);
    var f = e;
    return x(e) && !x(r) && (f = d(e, n)), x(e) && x(r) ? (r.forEach(function(u, t) {
      if (s.call(e, t)) {
        var p = e[t];
        p && typeof p == "object" && u && typeof u == "object" ? e[t] = i(p, u, n) : e.push(u);
      } else
        e[t] = u;
    }), e) : Object.keys(r).reduce(function(u, t) {
      var p = r[t];
      return s.call(u, t) ? u[t] = i(u[t], p, n) : u[t] = p, u;
    }, f);
  }, j = function(e, r) {
    return Object.keys(r).reduce(function(n, f) {
      return n[f] = r[f], n;
    }, e);
  }, m = function(i, e, r) {
    var n = i.replace(/\+/g, " ");
    if (r === "iso-8859-1")
      return n.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(n);
    } catch {
      return n;
    }
  }, y = 1024, A = function(e, r, n, f, u) {
    if (e.length === 0)
      return e;
    var t = e;
    if (typeof e == "symbol" ? t = Symbol.prototype.toString.call(e) : typeof e != "string" && (t = String(e)), n === "iso-8859-1")
      return escape(t).replace(/%u[0-9a-f]{4}/gi, function(q) {
        return "%26%23" + parseInt(q.slice(2), 16) + "%3B";
      });
    for (var p = "", v = 0; v < t.length; v += y) {
      for (var c = t.length >= y ? t.slice(v, v + y) : t, a = [], h = 0; h < c.length; ++h) {
        var o = c.charCodeAt(h);
        if (o === 45 || o === 46 || o === 95 || o === 126 || o >= 48 && o <= 57 || o >= 65 && o <= 90 || o >= 97 && o <= 122 || u === O.RFC1738 && (o === 40 || o === 41)) {
          a[a.length] = c.charAt(h);
          continue;
        }
        if (o < 128) {
          a[a.length] = l[o];
          continue;
        }
        if (o < 2048) {
          a[a.length] = l[192 | o >> 6] + l[128 | o & 63];
          continue;
        }
        if (o < 55296 || o >= 57344) {
          a[a.length] = l[224 | o >> 12] + l[128 | o >> 6 & 63] + l[128 | o & 63];
          continue;
        }
        h += 1, o = 65536 + ((o & 1023) << 10 | c.charCodeAt(h) & 1023), a[a.length] = l[240 | o >> 18] + l[128 | o >> 12 & 63] + l[128 | o >> 6 & 63] + l[128 | o & 63];
      }
      p += a.join("");
    }
    return p;
  }, _ = function(e) {
    for (var r = [{ obj: { o: e }, prop: "o" }], n = [], f = 0; f < r.length; ++f)
      for (var u = r[f], t = u.obj[u.prop], p = Object.keys(t), v = 0; v < p.length; ++v) {
        var c = p[v], a = t[c];
        typeof a == "object" && a !== null && n.indexOf(a) === -1 && (r.push({ obj: t, prop: c }), n.push(a));
      }
    return g(r), e;
  }, R = function(e) {
    return Object.prototype.toString.call(e) === "[object RegExp]";
  }, S = function(e) {
    return !e || typeof e != "object" ? !1 : !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
  }, B = function(e, r) {
    return [].concat(e, r);
  }, C = function(e, r) {
    if (x(e)) {
      for (var n = [], f = 0; f < e.length; f += 1)
        n.push(r(e[f]));
      return n;
    }
    return r(e);
  };
  return b = {
    arrayToObject: d,
    assign: j,
    combine: B,
    compact: _,
    decode: m,
    encode: A,
    isBuffer: S,
    isRegExp: R,
    maybeMap: C,
    merge: E
  }, b;
}
export {
  w as __require
};
//# sourceMappingURL=index.es64.js.map
